import { searchOrganisationsHandler } from './overrides/searchOrganisationsHandler'

export const handlers = [
  searchOrganisationsHandler(),
]
